import React from "react"
import Carousel from "../../carousel/Carousel"
import ProductCard from "../../productsArchive/ProductCard"
import styled from "@emotion/styled"
import { IGatsbyImageData } from "gatsby-plugin-image"
import Edges from "../../Edges"
// import CustomBadge from "../../badges/CustomBadge"

import useRecommendedProducts from "./useRecommendedProducts"

interface IRecommendedProducts {
  product?: any
  recommendationsDisabled?: boolean
  heading: string
  customRecommendations: {
    title: string
    acfProduct: {
      microDescription: string
      badge: {
        backgroundColor: string
        label: string
        enabled: boolean
      }
    }
    uri: string
    product: {
      variants: [
        {
          price: string
          compareAtPrice: string
        }
      ]
      images: {
        altText: string
        gatsbyImageData: IGatsbyImageData
      }[]
    }
  }[]
}

const RecommendedProducts = ({
  product,
  heading,
  customRecommendations = [],
  recommendationsDisabled = false,
}: IRecommendedProducts) => {
  const { recommendedProducts } = useRecommendedProducts({
    productId: product?.shopifyId,
  })

  if (recommendationsDisabled) {
    return null
  }

  return (
    <>
      <Edges size="md">
        <div className="mx-auto mb-[65px]">
          {heading &&
            (recommendedProducts?.length > 0 ||
              customRecommendations?.length > 0) && (
              <h2 className=" mb-8 px-[15px] text-darkBlue sm:px-8 lg:px-0">
                {heading}
              </h2>
            )}
          <Container>
            {customRecommendations && (
              <Carousel
                sliderSettings={{
                  infinite: customRecommendations?.length > 3,
                  className: "recommended-products-slider",
                  slidesToShow: 3,
                }}
                minImages={3}
                checkLength={customRecommendations?.length}
                arrowColor="#072A3F"
              >
                {customRecommendations?.map((wpProduct, index) => {
                  return (
                    <div key={index} className="relative mt-auto">
                      <ProductCard
                        key={wpProduct.title}
                        title={wpProduct.title}
                        badge={wpProduct?.acfProduct?.badge}
                        url={wpProduct.uri}
                        price={wpProduct?.product?.variants?.[0]?.price}
                        compareAtPrice={
                          wpProduct?.product?.variants?.[0]?.compareAtPrice
                        }
                        featuredImage={wpProduct?.product?.media[0]?.preview}
                        microDescription={
                          wpProduct?.acfProduct?.microDescription
                        }
                        className="relative"
                      />
                    </div>
                  )
                })}
              </Carousel>
            )}

            {!customRecommendations && recommendedProducts?.length > 0 && (
              <Carousel
                sliderSettings={{
                  infinite: recommendedProducts?.length > 3,
                  className: "recommended-products-slider",
                  slidesToShow: 3,
                }}
                checkLength={recommendedProducts?.length}
                minImages={3}
                arrowColor="#072A3F"
              >
                {recommendedProducts?.map((rec, index) => {
                  return (
                    <div key={index}>
                      <ProductCard
                        title={rec?.title}
                        badge={rec?.wpProduct?.acfProduct?.badge}
                        url={rec?.wpProduct?.uri}
                        price={rec?.variants?.[0]?.price}
                        compareAtPrice={rec?.variants?.[0]?.compareAtPrice}
                        featuredImage={rec?.media[0]?.preview}
                        microDescription={
                          rec?.wpProduct?.acfProduct?.microDescription
                        }
                        className="mx-auto mb-[25px]"
                      />
                    </div>
                  )
                })}
              </Carousel>
            )}
          </Container>
        </div>
      </Edges>
    </>
  )
}
export default RecommendedProducts

const Container = styled.div`
  .slick-track {
    display: flex;
    align-items: center;
  }
`
